import BusinessModel from "@/components/common/BusinessModel";
import ClientLogo from "@/components/common/ClientLogo";
import IndustryServeSlider from "@/components/common/IndustryServeSlider";
import PortfolioOverview from "@/components/common/PortfolioOverview";
import Layout from "@/components/layout/Layout";
import Benefits from "@/components/services/common/Benefits";
import ServiceFaqs from "@/components/services/common/ServiceFaqs";
import ServicesHeader from "@/components/services/common/ServicesHeader";
import CustomSoftwareAccordion from "@/components/services/custom-software-development/CustomSoftwareAccordion";
import {
  CUSTOM_SOFTWARE_DETAIL,
  CUSTOM_SOFTWARE_FAQ_DATA,
  CUSTOM_SOFTWARE_INNER_PAGES_DATA,
  CUSTOM_SOFTWARE_SCHEMA,
  CUSTOM_SOFTWARE_TITLE,
  CUSTOM_SOFTWARE_URL,
  VALUE_SECTION_DATA,
} from "const/services/custom-software-development";
import Image from "next/image";
import Link from "next/link";

const CustomSoftwareDevelopment = () => {
  return (
    <Layout
      canonicalLink={CUSTOM_SOFTWARE_URL}
      description={CUSTOM_SOFTWARE_DETAIL}
      keywords={
        "custom software development company custom application development company custom software development services custom software developer custom software development firm"
      }
      ogDescription={CUSTOM_SOFTWARE_DETAIL}
      ogImage={
        "https://ultroneous.com/assets/services/custom-software/custom-software-og.webp"
      }
      ogTitle={CUSTOM_SOFTWARE_TITLE}
      ogType={"custom software development company"}
      ogUrl={CUSTOM_SOFTWARE_URL}
      schema={{ ...CUSTOM_SOFTWARE_SCHEMA }}
      title={CUSTOM_SOFTWARE_TITLE}
      twitterDescription={CUSTOM_SOFTWARE_DETAIL}
      twitterImage={
        "https://ultroneous.com/assets/services/custom-software/custom-software-og.webp"
      }
      twitterTitle={CUSTOM_SOFTWARE_TITLE}
    >
      <ServicesHeader
        details="ultroNeous is an all-in-one <a href='https://ultroneous.com/'> software development company</a>, who can assist you at all points of the custom software development stages. Be it building a product development or creating a highly scalable mobile application with unique UI/UX designs, or building the <a href='/digital-marketing-services'>digital marketing</a> strategy of your brand or maintaining your product with AMC; we have the skills and expertise for each. Let us leverage our software development services and take care of your entire development process in a structured and methodical way."
        heading="Custom Software Development"
        pageName="Custom Software Development"
      />
      <CustomSoftwareAccordion data={CUSTOM_SOFTWARE_INNER_PAGES_DATA} />
      <div className="py-8 md:py-16 bg-primary-black">
        <ClientLogo />
      </div>
      <div className="py-12 md:py-16 md:px-8 xl:px-10">
        <h2 className="text-4xl md:text-6xl text-center font-medium text-black p-4 xl:p-12">
          <span>Our Software Development Methodologies</span>
        </h2>
        <div className="flex flex-col md:flex-row">
          <div className="border border-solid border-gray-400/40 w-auto md:w-1/2 bg-white rounded-2xl p-4 xl:p-12 m-4 md:ml-0">
            <Image
              alt="Agile Methodology"
              height={60}
              src="/assets/services/custom-software/agile.webp"
              title="Agile Methodology"
              width={60}
            />
            <h3 className="pt-4 text-xl md:text-3xl">
              <span>Agile Methodology</span>
            </h3>
            <p className="pt-6 text-base text-justify mb-0 [&_a]:text-[#00b1f0]">
              <span>
                Our impressive record of successful project management can be
                attributed to the implementation of&nbsp;
                <Link href="https://sites.google.com/view/agile-methodology-software/">
                  <a target="_blank">agile methodology</a>
                </Link>
                . By breaking down custom software development projects into
                smaller stages, we are able to ensure a seamless collaborative
                process and can adapt to any unexpected changes that may arise.
                Our team of certified Scrum Masters and product owners
                effectively prioritize tasks, assign roles, and maintain time
                frames. Using SCRUM, a proven agile methodology framework; we
                foster transparent collaboration, teamwork, and progress toward
                achieving your project goals with defined productive sprints.
              </span>
            </p>
          </div>
          <div className="border border-solid border-gray-400/40 w-auto md:w-1/2 bg-white rounded-2xl p-4 xl:p-12 m-4 md:mr-0">
            <Image
              alt="Waterfall Methodology"
              height={60}
              src="/assets/services/custom-software/waterfall.webp"
              title="Waterfall Methodology"
              width={60}
            />
            <h3 className="pt-4 text-xl md:text-3xl">
              <span>Waterfall Methodology</span>
            </h3>
            <p className="pt-6 text-base text-justify mb-0">
              <span>
                Waterfall methodology is a structured and sequential approach to
                project management. It aligns with our commitment to
                high-quality standards and timely delivery. Each project phase
                is meticulously completed before moving on to the next, ensuring
                a smooth workflow. As we prioritize the amount and quality of
                work done at the beginning, it becomes the whole software
                development cycle’s success. Our team works proactively and
                strategically to achieve all planned objectives, putting your
                project on just the right path.
              </span>
            </p>
          </div>
        </div>
      </div>
      <Benefits data={VALUE_SECTION_DATA} />
      <IndustryServeSlider />
      <BusinessModel />
      <PortfolioOverview />
      <ServiceFaqs data={CUSTOM_SOFTWARE_FAQ_DATA} />
    </Layout>
  );
};

export default CustomSoftwareDevelopment;
